import { createVNode as i, mergeProps as n } from "vue";
import p from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ZipTwoTone.js";
import m from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return i(m, n(t, {
    icon: p
  }), null);
};
o.displayName = "ZipTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
